import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

/** Accent of the optional status icon shown above the card title. */
export type AuthShellIconTone = 'primary' | 'success' | 'danger';

/** Shared centered authentication frame with the project logo, form card and legal links. */
@Component({
  imports: [NgOptimizedImage, RouterLink],
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'auth-shell-host',
  },
})
export class AuthShellComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>('');
  readonly icon = input<string>('');
  readonly iconTone = input<AuthShellIconTone>('primary');
}
